import styled, { css } from 'styled-components'
import { FooterStyleType, InsertStyleType } from 'src/types/type'
import { generateMedia } from 'styled-media-query'

const Mkt04CustomMedia = generateMedia({
  minLayout: '320px',
  midLayout: '360px',
  maxLayout: '884px',
})

const Mkt04Wrap = styled.div<Pick<InsertStyleType, 'mainBg'>>`
  ${Mkt04CustomMedia.lessThan('minLayout')`
    max-width: 320px;
 `}

  ${Mkt04CustomMedia.between('minLayout', 'midLayout')`
    max-width: 360px;
  `}
  ${Mkt04CustomMedia.greaterThan('midLayout')`
    max-width: 884px;
  `}
  margin: 0 auto;
  background-color: ${(props) => props.mainBg};
`

const Mkt04responsiveWidth = css`
  @media (min-width: 320px) {
    width:100%;
  }
  @media (min-width: 321px) and (max-width: 360px) {
      width:100%;
  }
  @media (min-width: 361px) {
      width:100%;
  }
`

const HeaderWrap = styled.div`
  width: 100%;
  display: flex;
  height: 37px;
  padding: 8px 16px;
  align-items: center;
  align-self: stretch;
`
const commonStyles = css`
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
`

const HeaderText = styled.div`
  width: 100%;
  ${commonStyles}

  span {
    color: #ff4545;
    ${commonStyles}
  }
`

const HeaderHR = styled.div`
  display: flex;
  height: 1px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  align-self: stretch;
  background-color: #e6e6e6;
`
const FooterWrap = styled.div<FooterStyleType>`
  display: flex;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;

  background-color: ${(props) => props.backgroundColor};
  color: ${(props) => props.color};
`
const FooterSection = styled.section`
  color: #000;
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -1px;
  > ul {
    padding: 0 0 0 20px;

    .important {
      font-weight: bold;
    }
  }
`

export {
  Mkt04CustomMedia,
  Mkt04Wrap,
  Mkt04responsiveWidth,
  HeaderWrap,
  HeaderText,
  HeaderHR,
  FooterWrap,
  FooterSection,
}
